import { create } from 'zustand';
import { persist } from 'zustand/middleware';

import { CartStore } from '../types/StoreTypes';

export const useCartStore = create<CartStore>()(
  persist(
    (set) => ({
      validatedCartData: null,

      setValidatedCartData: (data) =>
        set({
          validatedCartData: data,
        }),

      clearCartData: () =>
        set({
          validatedCartData: null,
        }),
    }),
    {
      name: 'cart-storage',
    },
  ),
);
